export enum StoreTemplateId {
  BASIC_RETAIL = "basic_retail",
  CAFE = "cafe",
  RESTAURANT = "restaurant",
  BAR = "bar",
  TAKEAWAY = "takeaway",
  SERVICE = "service",
}
